import * as React from 'react';

const MoneyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path d="M17.692 16.874c-.752 0-1.384-.256-1.897-.77-.513-.512-.77-1.144-.77-1.897 0-.752.257-1.384.77-1.897.513-.513 1.145-.77 1.897-.77.753 0 1.385.257 1.898.77.513.513.77 1.145.77 1.897s-.257 1.385-.77 1.898c-.513.513-1.145.769-1.898.769Zm-8.871 4.564c-.495 0-.926-.184-1.294-.552-.368-.368-.552-.8-.552-1.294V8.822c0-.494.184-.925.552-1.293.368-.368.8-.552 1.294-.552h17.743c.495 0 .926.184 1.294.552.368.368.552.8.552 1.294v10.769c0 .494-.184.926-.552 1.294-.368.368-.8.552-1.294.552H8.821Zm1.64-1.025h14.462c0-.677.242-1.257.727-1.74a2.374 2.374 0 0 1 1.735-.722v-7.487a2.366 2.366 0 0 1-1.739-.726 2.374 2.374 0 0 1-.723-1.736H10.462c0 .677-.242 1.257-.726 1.739A2.373 2.373 0 0 1 8 10.464v7.487c.677 0 1.257.242 1.739.726.482.485.723 1.063.723 1.736Zm14 4.41H5.437c-.494 0-.926-.184-1.294-.552-.368-.369-.552-.8-.552-1.294V10.925h1.026v12.052c0 .205.085.393.256.564.171.17.36.256.564.256h19.026v1.026Zm-15.64-4.41H8V8.003h.82a.789.789 0 0 0-.577.243.789.789 0 0 0-.244.577v10.769c0 .222.081.415.244.577a.789.789 0 0 0 .577.244Z" />
    </g>
  </svg>
);

export default MoneyIcon;
